import { useEffect } from 'react';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
interface MetaPixelWindow extends Window {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
  __metaPixelInitialized?: string;
}

// Meta Pixel — Aprende Coreano Fácil
const PIXEL_ID = '2120784785186386';

/**
 * Loads the Meta Pixel once and fires a single PageView.
 * Equivalent to Meta's official base code snippet, adapted for React.
 */
export function MetaPixel() {
  useEffect(() => {
    const pixelWindow = window as MetaPixelWindow;

    // Guard against double init / duplicate PageView (remounts, hot reload).
    if (pixelWindow.__metaPixelInitialized === PIXEL_ID) return;
    pixelWindow.__metaPixelInitialized = PIXEL_ID;
    if (!pixelWindow.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue.push(args);
        }
      }) as PixelFunction;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      pixelWindow.fbq = fbq;
      if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.id = 'meta-pixel-script';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    pixelWindow.fbq('init', PIXEL_ID);
    pixelWindow.fbq('track', 'PageView');
  }, []);
  return null;
}